export const DAILY_SNAPSHOT_CHANNELS = {
  DIRECT: 'Direct',
  SELF_DELIVERY: 'SelfDelivery',
  MARKETPLACE: 'Marketplace',
  ALL: 'All'
};

/**
 * Analytics datepicker period indexes.
 * Yesterday uses 7 so existing saved indexes (This week…Custom = 2–6) stay valid;
 * UI still renders Yesterday directly under Today.
 */
export const ANALYTICS_DATEPICKER_INDEX = {
  ALL_PERIOD: 0,
  TODAY: 1,
  THIS_WEEK: 2,
  LAST_WEEK: 3,
  THIS_MONTH: 4,
  LAST_MONTH: 5,
  CUSTOM_RANGE: 6,
  YESTERDAY: 7
};

export const DAILY_SNAPSHOT_CHANNEL_OPTIONS = [
  {label: 'Combined', value: DAILY_SNAPSHOT_CHANNELS.ALL},
  {label: 'Sauce Storefront', value: DAILY_SNAPSHOT_CHANNELS.DIRECT},
  {label: 'Self Delivery', value: DAILY_SNAPSHOT_CHANNELS.SELF_DELIVERY},
  {label: 'Marketplace', value: DAILY_SNAPSHOT_CHANNELS.MARKETPLACE}
];

export const resolveDailySnapshotOrders = (info, channel, isDirectOnly) => {
  if (isDirectOnly && channel === DAILY_SNAPSHOT_CHANNELS.SELF_DELIVERY) {
    return 0;
  }
  if (channel === DAILY_SNAPSHOT_CHANNELS.ALL) {
    return info?.sales?.yesterdayOrders;
  }
  return info?.sales?.yesterdayByChannel?.[channel]?.orders ?? 0;
};

export const resolveDailySnapshotSales = (info, channel, isDirectOnly) => {
  if (isDirectOnly && channel === DAILY_SNAPSHOT_CHANNELS.SELF_DELIVERY) {
    return 0;
  }
  if (channel === DAILY_SNAPSHOT_CHANNELS.ALL) {
    return info?.sales?.yesterdayTotal;
  }
  return info?.sales?.yesterdayByChannel?.[channel]?.totalSum ?? 0;
};

export const resolveSuccessMetric = (info, channel, isDirectOnly, field) => {
  if (isDirectOnly && channel === DAILY_SNAPSHOT_CHANNELS.SELF_DELIVERY) {
    return 0;
  }
  if (channel === DAILY_SNAPSHOT_CHANNELS.ALL) {
    if (field === 'orders') return info?.sales?.allTimeOrders;
    if (field === 'totalSum') return info?.sales?.allTimeTotal;
    if (field === 'customers') return info?.customers?.allTimeTotal;
    if (field === 'commissionSaved') return info?.commissionSaved;
    return 0;
  }
  return info?.allTimeByChannel?.[channel]?.[field] ?? 0;
};

export const ANALYTICS_SORT_FIELDS = {
  rank: 'rank',
  name: 'name',
  totalOrders: 'ordersAmount',
  totalSales: 'salesAmount'
};

export const ANALYTICS_CHART_COLORS = {
  avgLine: '#FF2D38',
  salesCountGross: '#3A86FF',
  salesCountOrders: '#F5A623'
};

export const ANALYTICS_ITEMS_PAGE_SIZE = 14;

// Analytics channel + fulfillment breakdown (GROW-2435)
export const ANALYTICS_CHANNELS = {
  ALL: 'all',
  SAUCE_STOREFRONT: 'sauce_storefront',
  UBER: 'uber',
  GRUBHUB: 'grubhub',
  DOORDASH: 'doordash',
  SLICE: 'slice'
};

// Labels for known channels. The picker options themselves come from
// GET /api/v3/analytics-v3/{locationId}/channels; unknown keys fall back to the raw value.
export const ANALYTICS_CHANNEL_OPTIONS = [
  {label: 'All Channels', value: ANALYTICS_CHANNELS.ALL},
  {label: 'Sauce Storefront', value: ANALYTICS_CHANNELS.SAUCE_STOREFRONT},
  {label: 'Uber Eats', value: ANALYTICS_CHANNELS.UBER},
  {label: 'Grubhub', value: ANALYTICS_CHANNELS.GRUBHUB},
  {label: 'DoorDash', value: ANALYTICS_CHANNELS.DOORDASH},
  {label: 'Slice', value: ANALYTICS_CHANNELS.SLICE}
];

export const ANALYTICS_FULFILLMENT_MODES = {
  ALL: 'all',
  PICKUP: 'pickup',
  SAUCE_DELIVERY: 'sauce_delivery',
  THIRD_PARTY_DELIVERY: '3rd_party_delivery',
  LOCATION_DELIVERY: 'location_delivery'
};

export const ANALYTICS_FULFILLMENT_OPTIONS = [
  {label: 'All Fulfillments', value: ANALYTICS_FULFILLMENT_MODES.ALL},
  {label: 'Pickup', value: ANALYTICS_FULFILLMENT_MODES.PICKUP},
  {label: 'Sauce Delivery', value: ANALYTICS_FULFILLMENT_MODES.SAUCE_DELIVERY},
  {
    label: '3rd Party Delivery',
    value: ANALYTICS_FULFILLMENT_MODES.THIRD_PARTY_DELIVERY
  },
  {
    label: 'Location Delivery',
    value: ANALYTICS_FULFILLMENT_MODES.LOCATION_DELIVERY
  }
];

export const ANALYTICS_FULFILLMENT_LABELS = {
  ...ANALYTICS_FULFILLMENT_OPTIONS.reduce(
    (labels, option) => ({...labels, [option.value]: option.label}),
    {}
  ),
  // Returned by the BFF for orders without a known classification.
  unclassified: 'Unclassified'
};

export const ANALYTICS_CHANNEL_LABELS = {
  ...ANALYTICS_CHANNEL_OPTIONS.reduce(
    (labels, option) => ({...labels, [option.value]: option.label}),
    {}
  ),
  // Returned by the BFF for orders without a known source/platform.
  unknown: 'Unknown'
};
